// Toast igual ao do usina.js: um por vez, some em 2,8 s. Usa a classe `.toast` do sistema visual.
let timer: ReturnType<typeof setTimeout> | null = null;

export function toast(msg: string, kind: '' | 'err' = '') {
  document.querySelector('.toast')?.remove();
  const el = document.createElement('div');
  el.className = `toast ${kind}`;
  el.textContent = msg;
  document.body.appendChild(el);
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => el.remove(), 2800);
}
